import { useState } from 'react';
import { ReactComponent as TagNotFound } from 'assets/img/tag-management-not-found.svg';
import { DataRow, EventAction } from 'plugins/types';
import ELEMENT from 'common/element';
import Button, { ButtonVariant } from 'components/common/Button/Button';
import { manageTagsAction } from '../../actions/sentinel-one/actions';
import EventActionsExecutor from '../../actions/sentinel-one/EventActionsExecutor';
import './EndpointTagsEmptyState.scss';

interface EndpointTagsEmptyStateProps {
  logEntry: DataRow;
}

export const EndpointTagsEmptyState = ({ logEntry }: EndpointTagsEmptyStateProps): JSX.Element => {
  const [selectedAction, setSelectedAction] = useState<EventAction | null>(null);
  return (
    <div className="Tags__MainSectionContainer">
      <TagNotFound className="Tags__Image" />
      <div className="Tags__DialogEmptyTitle">No Tags Are Applied On This Endpoint</div>
      <Button
        className="Tags__ManageButton"
        variant={ButtonVariant.SECONDARY}
        testId={ELEMENT.graphDisplaySettingsLinear}
        onClick={() => setSelectedAction(manageTagsAction)}
      >
        Manage Endpoint Tags
      </Button>
      <EventActionsExecutor
        action={selectedAction}
        values={logEntry}
        actionCompleteCallback={() => setSelectedAction(null)}
      />
    </div>
  );
};

export default EndpointTagsEmptyState;
